/**
 * Platform (Watchly staff) role names. Kept in sync with User::PLATFORM_* and
 * AdminUser.ts PLATFORM_ROLES — tenant membership UI must ignore these when
 * picking the single org role to show or edit.
 */
const PLATFORM_ROLE_NAMES = ['Watchly Super Admin', 'Watchly Account Manager'] as const;

/**
 * The member's current tenant role for the Manage panel Select. Tenant members
 * hold at most one; if a leftover stack exists, the first non-platform name
 * wins. Platform-only staff (no tenant role yet) yield null.
 */
const tenantRoleFrom = (roles: string[]): string | null => {
    const tenant = roles.find(role => !(PLATFORM_ROLE_NAMES as readonly string[]).includes(role));
    return tenant ?? null;
};

export { PLATFORM_ROLE_NAMES, tenantRoleFrom };
